var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.581055,
    width: 119.124,
    height: 119,
    rx: 59.5,
    fill: "#FFF5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6133,
    y: 76.9141,
    width: 58.0604,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6133,
    y: 57.5859,
    width: 58.0604,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6133,
    y: 38.25,
    width: 58.0604,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8711,
    y: 31,
    width: 4.83837,
    height: 19.3333,
    rx: 2.41918,
    fill: "#D91F05"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1587,
    y: 50.3359,
    width: 4.83837,
    height: 19.3333,
    rx: 2.41918,
    fill: "#D91F05"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6436,
    y: 69.6641,
    width: 4.83837,
    height: 19.3333,
    rx: 2.41918,
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.621da7064f15616b53c4f7d48f70998d.svg";
export { ForwardRef as ReactComponent };